export default __webpack_public_path__ + "static/media/2543.1f9065eb.png";